import Vue from "vue";
import "es6-promise/auto";
import Vuex from "vuex";
import defaultState from './defaultState';
import defaultMutations from './defaultMutations';
import listModules from './modules/listModules';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: defaultState,
    mutations: defaultMutations,
    actions: {},
    getters: {},
    modules: {
        listModules,
    }
})

export default store